export const analyticsConsentKey = 'ncg:analytics-consent'

export function hasAnalyticsConsent() {
  return window.localStorage.getItem(analyticsConsentKey) === 'accepted'
}

export function removeAnalyticsCookies() {
  for (const cookie of document.cookie.split(';')) {
    const name = cookie.split('=')[0]?.trim()
    if (name?.startsWith('_ga')) {
      document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`
      document.cookie = `${name}=; Max-Age=0; Path=/; Domain=${window.location.hostname}; SameSite=Lax`
    }
  }
}

export function resetAnalyticsConsent() {
  window.localStorage.removeItem(analyticsConsentKey)
  window.gtag?.('consent', 'update', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  })
  removeAnalyticsCookies()
  window.dispatchEvent(new Event('ncg:analytics-consent-reset'))
}
